import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

type UseCurrentChannel = {
  channel: string | null;
  setChannel: (channel: string | null) => void;
};

export const useCurrentChannel = (): UseCurrentChannel => {
  const [searchParams, setSearchParams] = useSearchParams();
  const channelFromUrl = searchParams.get('channel');

  return useMemo(
    () => ({
      channel: channelFromUrl,
      setChannel: (channel: string | null) => {
        if (channel && channel.length > 0) {
          searchParams.set('channel', channel);
        } else {
          searchParams.delete('channel');
        }
        setSearchParams(searchParams);
      },
    }),
    [channelFromUrl, searchParams, setSearchParams]
  );
};
